import Common from "~/Common/JSX/Components/Common.jsx";

export default class Development {

	developmentMode = null;
	logData = [];

	enableDevelopmentMode() {

		let logLength = this.logData.length;
		
		this.developmentMode = true;
		
		for( let i = 0; i < logLength; i++ ) {
			
			console.log( this.logData[i].arguments );
		}

		this.logData = [];
	}

	getBrowserInfo() {

		return {
			appCodeName: window.navigator.appCodeName,
			appMinorVersion: window.navigator.appMinorVersion,
			appName: window.navigator.appName,
			appVersion: window.navigator.appVersion,
			cookieEnabled: window.navigator.cookieEnabled,
			cpuClass: window.navigator.cpuClass,
			doNotTrack: window.navigator.doNotTrack,
			languague: window.navigator.language,
			mimeTypes: window.navigator.mimeTypes,
			onLine: window.navigator.onLine,
			opsProfile: window.navigator.opsProfile,
			oscpu: window.navigator.oscpu,
			platform: window.navigator.platform,
			plugins: window.navigator.plugins,
			systemLanguage: window.navigator.systemLanguage,
			userAgent: window.navigator.userAgent,
			userLanguage: window.navigator.userLanguage,
			userProfile: window.navigator.userProfile,
		};
	}

	getMode() {
		
		if( this.developmentMode === null ) {

			this.initializeMode();
		}
		return this.developmentMode;
	}

	initializeMode() {

		if( pitv2.environment === "development" ) {

			this.developmentMode = true;
		} else {

			this.developmentMode = false;
		}
	}

	log() {

		let args = [ ...arguments ];
		let parameters = {
			arguments: args,
			location: window.location,
			browser: this.getBrowserInfo(),
		};

		if( this.getMode() === true ) {

			console.log( parameters.arguments );
		} else {

			this.logData.push( parameters );
		}
	}
	
	remoteLog( parameters ) {

		Common.post( "/wp-admin/admin-ajax.php", {
			"action": "pit",
			"class": ".PIT.Pub.Development",
			"function": "log",
			"parameters": JSON.stringify( parameters ),
		} );
	}
}